import facebookhumano from "../assets/img/facebookhumano.svg";
import twitterhumano from "../assets/img/twitterhumano.svg";
import instagramhumano from "../assets/img/instagramhumano.svg";
import youtubehumano from "../assets/img/youtubehumano.svg";

import facebookprimera from "../assets/img/facebookprimera.svg";
import twitterprimera from "../assets/img/twitterprimera.svg";
import instagramprimera from "../assets/img/instagramprimera.svg";
import youtubeprimera from "../assets/img/youtubeprimera.svg";

import LogoPrimeraBlanco from "../assets/img/logo-primera-blanco.png";
import LogoPrimeraAzul from "../assets/img/logo-primera-azul.png";
import LogoHumanoBlanco from "../assets/img/logo-humano-blanco.png";
import LogoHumanoAzul from "../assets/img/logo-humano-seguro-azul.jpg";

import Colors from "../themes/Colors";
import Fonts from "../themes/Fonts";

const EmpresaUtil = {
  96: {
    NOMBRE: "ARS Primera",
    CODIGO: "96",
    TIPO_CLIENTE: "Afiliado",
    PREFIJO_AUTORIZACION: "P",
    LOGO_BLANCO: LogoPrimeraBlanco,
    LOGO_AZUL: LogoPrimeraAzul,
    COLOR_PRINCIPAL: Colors.primaryPrimera,
    COLOR_SECUNDARIO: Colors.darkGreenPrimera,
    LETRA_PRINCIPAL: Fonts.familyHelveticaLight,
    FONDO: "./images/fondoprimera.png",
    REDES: {
      FACEBOOK: {
        URL: "https://www.facebook.com/ARSprimera",
        ICON: facebookprimera,
      },
      TWITTER: {
        URL: "https://twitter.com/arsprimera",
        ICON: twitterprimera,
      },
      INSTAGRAM: {
        URL: "https://www.instagram.com/primeraars",
        ICON: instagramprimera,
      },
      YOUTUBE: {
        URL: "https://www.youtube.com/c/PrimeraARS",
        ICON: youtubeprimera,
      },
    },
    CAROUSEL: [
      {
        IMAGEN: "./images/banerprimera1.png",
        LINK: "https://humanopss.educologyhub.com/",
      },
      {
        IMAGEN: "./images/banerprimera2.png",
        LINK: "https://arsprimera.com/Servicios/Paginas/App-Humano.aspx",
      },   
      {
        IMAGEN: "./images/bannerhp3.png",
        LINK: "https://humanoseguros.com/DTL_Descargables/MicrosoftTeams-image%20(3).png",
      },
    ],
    CHAT: "https://go.botmaker.com/rest/webchat/p/PYHWVA73TU/init.js",
    REDIRECT_COMPANY : {
      URL: process.env.REACT_APP_REDIRECT_URL_HUMANO,
      NAME: "Humano Seguros",
      MESSAGE : "El número de asegurado que has digitado pertenece a Humano Seguros, para procesar tu autorización, favor ingresar al siguiente enlace:"
    }
  },
  30: {
    NOMBRE: "Humano Seguros",
    CODIGO: "30",
    TIPO_CLIENTE: "Asegurado",
    PREFIJO_AUTORIZACION: "H",
    LOGO_BLANCO: LogoHumanoBlanco,
    LOGO_AZUL: LogoHumanoAzul,
    COLOR_PRINCIPAL: Colors.primaryHumano,
    COLOR_SECUNDARIO: Colors.grayFont,
    LETRA_PRINCIPAL: Fonts.familyVerlag,
    FONDO: "./images/fondohumano.jpg",
    REDES: {
      FACEBOOK: {
        URL: "https://www.facebook.com/humanoseguros",
        ICON: facebookhumano,
      },
      TWITTER: {
        URL: "https://twitter.com/seguroshumano",
        ICON: twitterhumano,
      },
      INSTAGRAM: {
        URL: "https://www.instagram.com/humanoseguros",
        ICON: instagramhumano,
      },
      YOUTUBE: {
        URL: "https://www.youtube.com/@Humanoseguros",
        ICON: youtubehumano,
      },
    },
    CAROUSEL: [
      {
        IMAGEN: "./images/banerhumano1.jpg",
        LINK: "https://humanoseguros.com/Paginas/GlobalHealthClassic.aspx",
      },
      {
        IMAGEN: "./images/banerhumano2.jpg",
        LINK: "https://humanoseguros.com/Paginas/PrimerNivel.aspx?ID=827",
      },
      {
        IMAGEN: "./images/bannerhp3.png",
        LINK: "https://humanoseguros.com/DTL_Descargables/MicrosoftTeams-image%20(3).png",
      },
    ],
    CHAT: "https://go.botmaker.com/rest/webchat/p/LWSJ2WP2MR/init.js",
    REDIRECT_COMPANY : {
      URL: process.env.REACT_APP_REDIRECT_URL_PRIMERA,
      NAME: "ARS Primera",
      MESSAGE : "El número de afiliado que has digitado pertenece a ARS Primera, para procesar tu autorización, favor ingresar al siguiente enlace:"
    }
  },
};

export default EmpresaUtil;